import * as React from 'react';
import VoxelAutocompleteCity from '../../../../../components/muiLegacy/Autocomplete/VoxelAutocompleteCity';
import VoxelAutocompleteCountry, {
  globalOption,
} from '../../../../../components/muiLegacy/Autocomplete/VoxelAutocompleteCountry';
import VoxelAutocompleteLanguage from '../../../../../components/muiLegacy/Autocomplete/VoxelAutocompleteLanguage';
import { SearchRequestTypes } from '../../../../../components/muiLegacy/Tables/KeywordTable/ToolbarButtons/AddKeywords/AddBasicKeywords/logic/SearchModels';
import VoxelCheckbox from '../../../../../components/voxel/Forms/VoxelCheckbox';
import VoxelSelect from '../../../../../components/voxel/Forms/VoxelSelect';
import { GoogleAdsRequestAnalysisGq } from '../../../../../graphql/projects/models/GoogleAdsRequestAnalysisGq';
import { GoogleAdsRequestTypeGq } from '../../../../../graphql/projects/models/GoogleAdsRequestTypeGq';
import LongTailCheckboxes from '../LongTailCheckboxes';
import SearchTypeInputFields from '../SearchTypeInputFields';
import { validLongTailLanguages } from '../QuickSearchForm/logic/QuickSearchModels';
import { setupSearchInfoForm } from './setupSearchInfoForm';
import VoxelText from '../../../../../components/voxel/Text/VoxelText';

export interface SearchInfoFormProps {
  selectedRequestId?: number;
  selectedProjectId?: number;
  selectedRequestAnalysis?: GoogleAdsRequestAnalysisGq;
  readOnly?: boolean;
}

const SearchInfoForm: React.FC<SearchInfoFormProps> = ({
  selectedRequestId,
  selectedRequestAnalysis,
  selectedProjectId,
  readOnly
}) => {
  const formBag = setupSearchInfoForm({
    selectedRequestId,
    selectedProjectId,
    selectedRequest: selectedRequestAnalysis?.request,
  });

  const validLongtailLanguage =
    !formBag.values.language?.name ||
    validLongTailLanguages.includes(formBag.values.language?.name);

  return (
    <div className="w-full flex flex-col gap-6">
      <div className="w-full flex flex-col gap-4">
        <VoxelSelect
          disabled
          id={'requestType'}
          size='sm'
          label="Search type"
          labelPosition="top"
          setSelectedOption={(option) =>
            formBag.setFieldValue(
              'requestType',
              SearchRequestTypes?.find((type) => type?.type === option.value)?.type
            )
          }
          selectedOptionValue={formBag?.values?.requestType}
          options={SearchRequestTypes.map((t) => ({
            title: t.name,
            value: t.type,
            subtitle: t.shortDescription,
          }))}
        />
        <VoxelAutocompleteLanguage
          disabled
          type="both"
          selectedLanguage={formBag?.values?.language}
          setSelectedLanguage={(language) => formBag.setFieldValue('language', language)}
          inputWidthClass="w-full"
          labelPosition='top'
          size='sm'
        />
        <VoxelAutocompleteCountry
          disabled
          type="both"
          selectedCountry={formBag?.values?.country}
          setSelectedCountry={(country) => formBag.setFieldValue('country', country)}
          clearSelectedCity={() => formBag.setFieldValue('city', null)}
          inputWidthClass="w-full"
          labelPosition='top'
          size='sm'
        />
        {formBag.values.country?.id !== globalOption.id && (
          <VoxelAutocompleteCity
            disabled
            type="both"
            labelPosition='top'
            selectedCountry={formBag?.values?.country}
            selectedCity={formBag?.values?.city}
            setSelectedCity={(city) => formBag.setFieldValue('city', city)}
            inputWidthClass="w-full"
            size='sm'
          />
        )}
      </div>
      <div className="flex flex-col gap-6">
        <SearchTypeInputFields
          readOnly
          formik={formBag}
        />
        {formBag.values.requestType === GoogleAdsRequestTypeGq.LONG_TAIL && (
          <LongTailCheckboxes
            disabled
            formik={formBag}
            validLongtailLanguage={validLongtailLanguage}
            helperText={formBag.errors.suggestionsWord}
          />
        )}
        <div>
          <VoxelText variant='form-caption' paddingBot>More options</VoxelText>
          <VoxelCheckbox
            disabled
            padding
            label='Include zero volume'
            checked={formBag?.values?.includeZeroVolume}
            onChange={(value: boolean) => formBag.setFieldValue('includeZeroVolume', value)}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchInfoForm;
